import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';

type AlertProps = PropsWithChildren<{
    type: 'success' | 'error' | 'info';
}>;

export const Alert = ({ type, children }: AlertProps) => {
    return (
        <div
            className={`flex justify-center items-center rounded-lg border px-2 py-3 ${classNames({
                'border-green-400 bg-green-100 text-green-600': type === 'success',
                'bg-danger-100 text-danger-300  border-danger-300': type === 'error',
            })}`}
        >
            {children}
        </div>
    );
};
